<template>
  <div class="elasticComputeCloudResourceGcpSearch">
    <Row :gutter="4" style="margin-bottom: 10px">
      <div v-if="companyIdShow == 1">
        <Col span="6">
          <Select
            v-model="companyId"
            @on-change="changeCompanyID"
            :placeholder="$t('RAM.common.PleaseSelectCompany')"
            :transfer="true"
          >
            <Option
              v-for="item in companyIdList"
              :value="item.id"
              :key="item.id"
              >{{ item.companyName }}</Option
            >
          </Select>
        </Col>
        <Col span="6">
          <!--按账户筛选  -->
          <Select
            v-model="accountSearchKey"
            filterable
            multiple
            :max-tag-count="1"
            :placeholder="$t('RAM.common.pleaseEnterAccount')"
            @on-change="changeAccountId(accountSearchKey)"
            :transfer="true"
          >
            <Checkbox
              v-model="singleAccount"
              @on-change="selectAccountAll"
              style="display: block; text-align: right"
              v-if="accountList.length > 0"
              >{{ $t("alarms.common.allSelected") }}</Checkbox
            >
            <Option
              :value="item.id"
              v-for="item in accountList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
        <Col span="6">
          <Input
            v-model="instanceId"
            :placeholder="$t('RAM.common.QuerybyInstanceID')"
          />
        </Col>

        <Col span="2">
          <Button
            v-hasPermission="[
              'resourceConfigurationManagement:gcp:elasticComputeCloudResourceGcp:page'
            ]"
            @click="search()"
            >{{ $t("alarms.common.search") }}</Button
          >
        </Col>
      </div>
    </Row>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../../utils/cookieUtil.js";
import TableElasticComputeCloudResourceGcp from "../ecs/TableElasticComputeCloudResourceGcp";
var tableElasticComputeCloudResourceGcp = TableElasticComputeCloudResourceGcp;
export default {
  name: "ElasticComputeCloudResourceGcpSearch",
  data() {
    return {
      companyIdShow: getCookie(global.companyId),
      companyId: "",
      companyIdList: [],
      accountSearchKey: [],
      accountList: [],
      instanceId: "",
      singleAccount: false
    };
  },
  mounted: function() {
    if (this.companyIdShow == 1) {
      this.listRegisterInformation();
    } else {
      // tableElasticComputeCloudResourceGcp.methods.showAll();
    }
  },
  methods: {
    //查询公司
    listRegisterInformation: function() {
      this.$api.user.listRegisterInformation().then(res => {
        // 获取公司列表数据
        this.companyIdList = res.data.companies;
        if (this.companyIdList) {
          this.companyId = this.companyIdList[0].id;
        }
        this.accountSearchKey = [];
        this.queryGCPAccountBox();
      });
    },
    /* 账号 */
    queryGCPAccountBox: function() {
      this.$api.account
        .queryGCPAccountBox("companyId", this.companyId)
        .then(res => {
          this.accountList = res.data;
          //默认账户全选
          if (this.accountList) {
            for (var i = 0; i < this.accountList.length; i++) {
              this.accountSearchKey.push(this.accountList[i].id);
            }
          }
        });
    },
    // 切换公司
    changeCompanyID: function() {
      this.accountSearchKey = [];
      this.queryGCPAccountBox();
    },
    // 切换账户
    changeAccountId: function(val) {
      if (val.length === this.accountList.length && val.length != 0) {
        this.singleAccount = true;
      } else {
        this.singleAccount = false;
      }
    },
    selectAccountAll() {
      this.accountSearchKey = [];
      if (this.singleAccount) {
        this.accountList.map(item => {
          this.accountSearchKey.push(item.id);
        });
      } else {
        this.accountSearchKey = [];
      }
    },
    // 按实例ID查询
    // searchInstanceId: function () {
    //   eventBus.$emit("instanceId", this.instanceId);
    //   tableElasticComputeCloudResourceGcp.methods.showAll();
    // },
    search: function() {
      eventBus.$emit("instanceName", this.instanceName);
      eventBus.$emit("instanceId", this.instanceId);
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("accountSearchKey", this.accountSearchKey);
      tableElasticComputeCloudResourceGcp.methods.showAll();
    }
  }
};
</script>
<style scoped>
.elasticComputeCloudResourceGcpSearch {
  padding: 4px 0px 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/gcp/ecs/ElasticComputeCloudResourceGcpSearch.vue